import { Box, ButtonBase } from '@mui/material';
import type { ReactNode } from 'react';
import { capsuleTabItemStyles, capsuleTabTrackStyles, tabItemStyles, tabListStyles } from './tabStyles';
import { usePageTabs } from './PageTabsContext';

export type FilterTabItem<Value extends string> = {
  value: Value;
  label: ReactNode;
  controls: string;
  disabled?: boolean;
};

export type FilterTabsProps<Value extends string> = {
  value: Value;
  items: readonly FilterTabItem<Value>[];
  ariaLabel: string;
  onChange: (value: Value) => void;
};

export function FilterTabs<Value extends string>({
  value,
  items,
  ariaLabel,
  onChange,
}: FilterTabsProps<Value>) {
  const pageTabs = usePageTabs();
  return <Box
    role="group"
    aria-label={ariaLabel}
    sx={{
      display: 'flex',
      alignItems: 'stretch',
      ...tabListStyles,
      ...(pageTabs ? capsuleTabTrackStyles : {}),
      overflowX: 'auto',
      scrollbarWidth: 'thin',
    }}
  >
    {items.map((item) => {
      const selected = item.value === value;
      return <ButtonBase
        key={item.value}
        type="button"
        aria-pressed={selected}
        aria-controls={item.controls}
        disabled={item.disabled}
        disableRipple
        onClick={() => onChange(item.value)}
        sx={pageTabs ? capsuleTabItemStyles : tabItemStyles}
      >
        {item.label}
      </ButtonBase>;
    })}
  </Box>;
}
